/* eslint-disable no-param-reassign */
import { call, put, take } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import moment from 'moment'
import firebase from '../config/firebase'

import ExpressActions from '../reducers/expressReducer'

const expressObserver = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(
      querySnapshot => {
        const express = {}

        querySnapshot.forEach(doc => {
          express[doc.id] = { ...doc.data(), id: doc.id }
        })

        emit(express)
      },
      err => {
        emit(new Error(err))
      }
    )

    return () => subscriber
  })

  return listener
}

export function* syncExpress() {
  const startOfTheDay = moment()
    .startOf('days')
    .format('x')

  const dbRef = firebase
    .firestore()
    .collection('express_orders')
    .where('created_at', '>=', Number(startOfTheDay))
    .where('status', 'in', ['pending', 'rejected', 'confirmed', 'outForDelivery', 'delivered'])
    .orderBy('created_at', 'desc')

  yield put(ExpressActions.setExpressLoading(true))
  const channel = yield call(expressObserver, dbRef)

  try {
    while (true) {
      const orders = yield take(channel)

      const instantDeliveries = {}
      const sameDayDeliveries = {}

      const orderKeys = Object.keys(orders)

      for (let index = 0; index < orderKeys.length; index += 1) {
        const orderKey = orderKeys[index]
        const order = orders[orderKey]

        switch (order.courier_type) {
          case 'instant_delivery':
          case undefined:
            instantDeliveries[orderKey] = order
            break;

          case 'same_day_delivery':
            sameDayDeliveries[orderKey] = order
            break;

          default:
            break;
        }
      }

      yield put(ExpressActions.setExpress(orders))
      yield put(ExpressActions.setInstantOrders(instantDeliveries))
      yield put(ExpressActions.setSameDayOrders(sameDayDeliveries))
      yield put(ExpressActions.setConnected(true))
      yield put(ExpressActions.setExpressLoading(false))
    }
  } finally {
    channel.close()
    yield put(ExpressActions.setExpressLoading(false))
  }
}

export function* getCodReport({ payload }) {
  try {
    const { startFrom, endAt, refunded = false } = payload

    const collection = firebase
      .firestore()
      .collection('express_orders')
      .where('created_at', '>=', Number(startFrom))
      .where('created_at', '<=', Number(endAt))
      .where('status', '==', 'delivered')
      .where('refunded', '==', refunded)
      .where('is_using_cod', '==', true)
      .orderBy('created_at', 'asc')

    const snapShot = yield call([collection, collection.get])
    const data = {}

    snapShot.forEach(doc => {
      data[doc.id] = { ...doc.data(), id: doc.id }
    })

    yield put(ExpressActions.setCodReport({ data }))
  } catch (error) {
    yield put(ExpressActions.setExpressCodLoading(false))
  }
}

export function* getExpressOrdersReport({ payload }) {
  try {
    const { startFrom, endAt } = payload

    const collection = firebase
      .firestore()
      .collection('express_orders')
      .where('created_at', '>=', Number(startFrom))
      .where('created_at', '<=', Number(endAt))
      .orderBy('created_at', 'asc')

    const snapshot = yield call([collection, collection.get])
    const data = []

    snapshot.forEach(doc => {
      data.push({ ...doc.data(), id: doc.id })
    })

    yield put(ExpressActions.setExpressOrdersReport(data))
  } catch (error) {
    yield put(ExpressActions.setExpressOrdersReport([]))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/expressSaga.js